import { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Badge } from '@leroy-merlin-br/backyard-react-ui'

import Glyph from 'reactGarden/Glyph'

const WAITING_ORDER_PICKUP = 'Aguardando retirada'

const OrderTitle = ({
  id,
  shipments,
  totalValue,
  date,
  fiscalId,
  isOpen,
  hasOrderToPay,
  payable,
  paymentUrl,
  serviceCount,
  hasOrderToPickUp = false
}) => {
  const shipmentCount = shipments.length
  const SHIPMENT_LABEL = shipmentCount === 1 ? 'entrega' : 'entregas'
  const SERVICE_LABEL = serviceCount > 1 ? 'serviços' : 'serviço'

  const PaymentOrderButton = () => {
    if (!payable || fiscalId) {
      return (
        <div className="order-item color-default">
          <p className="info">O pagamento desse pedido é possível apenas na Loja física</p>
        </div>)
    }
    return (
      <div className="order-item color-default">
        <a className="button button-primary button-full align-center payment-button" onClick={(e) => e.stopPropagation()} href={paymentUrl}> Pagar </a>
      </div>)
  }

  const orderBadge = () => {
    if (hasOrderToPickUp) {
      return (
        <Badge color="yellow">{ WAITING_ORDER_PICKUP }</Badge>
      )
    }

    return (
      <Badge color={isOpen ? 'gray' : 'green'} isLight>
        { shipmentCount } { SHIPMENT_LABEL }
        {
          serviceCount > 0 &&
            <Fragment>
              {' '}e { serviceCount } { SERVICE_LABEL }
            </Fragment>
        }
      </Badge>
    )
  }

  return (
    <div className="order-title">
      <div className="order-item color-primary">
        <strong>Pedido { id }</strong>
      </div>
      {hasOrderToPay && <PaymentOrderButton />}
      <div className="order-item color-default">
        <div className="small">Total</div>
        <strong>R$ { totalValue.integers },{ totalValue.decimals }</strong>
      </div>

      <div className="order-item color-default">
        <div className="small">Data do pedido</div>
        <strong>{ date }</strong>
      </div>

      <div className="order-item">
        {orderBadge()}
      </div>

      <div className="order-item color-primary">
        <Glyph glyph={isOpen ? 'double-arrow-up' : 'double-arrow-down'} />
      </div>
    </div>
  )
}

OrderTitle.propTypes = {
  id: PropTypes.string,
  shipments: PropTypes.array,
  totalValue: PropTypes.object,
  date: PropTypes.string,
  isOpen: PropTypes.bool,
  payable: PropTypes.bool,
  paymentUrl: PropTypes.string
}

export default OrderTitle
